(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loving-homepage"] && !Shopify.designMode) return;
  try {
    
  function initializeDressFilters(root) {
    root.querySelectorAll('.loving-edit').forEach(section => {
      const filters = section.querySelector('.loving-edit__filters');
      if (!filters || filters.dataset.initialized) return;
      filters.dataset.initialized = 'true';
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-look-filter]');
        if (!button) return;
        const category = button.dataset.lookFilter;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelectorAll('[data-look-category]').forEach(card => { card.hidden = category !== 'all' && card.dataset.lookCategory !== category; });
      });
    });
  }
  initializeDressFilters(document);
  document.addEventListener('shopify:section:load', event => initializeDressFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
